// extracted by mini-css-extract-plugin
module.exports = {"container":"ProseCosmos_container__GOaBr"};